import styled from 'styled-components';

/**
 * Span di testo statico che può essere utilizzato per mettere un testo
 * all'inizio di uno `<Space.Compact />`.
 */
export const SimilInputSpan = styled.div`
  /* font-size: 16px;
  line-height: 1.3;
  margin: 0; */
  min-height: 32px;
  border: 1px solid ${props => props.theme.colorBorder};
  border-radius: ${props => props.theme.borderRadius}px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  padding: 4px 11px;
  display: flex;
  align-items: center;
  background-color: ${props => props.theme.colorBgContainer};
  color: ${props => props.theme.colorText};
  border-right: none;
  transition: all 0.3s;
  min-width: 200px;
  width: 70%;
  .size-lg {
    /* font-size: 18px;
    line-height: 1.4; */
    min-height: 40px;
    padding: 7px 11px;
    border-top-left-radius: ${props => props.theme.borderRadiusLG}px;
    border-bottom-left-radius: ${props => props.theme.borderRadiusLG}px;
  }
`;
